import React, { forwardRef } from 'react'
import { ContainerProps } from './Container.types'
import { StyledContainer } from './Container.styles'

const Container = forwardRef<HTMLDivElement, ContainerProps>(
  (
    { children, maxWidth, fixed = false, disableGutters = false, ...props },
    ref
  ) => {
    return (
      <StyledContainer
        ref={ref}
        $maxWidth={maxWidth}
        $fixed={fixed}
        $disableGutters={disableGutters}
        {...props}
      >
        {children}
      </StyledContainer>
    )
  }
)

Container.displayName = 'Container'

export default Container
